export const timezones = {
  NSW: "Australia/Sydney",
  ACT: "Australia/Canberra",
  WA: "Australia/Perth",
  NT: "Australia/Darwin",
  TAS: "Australia/Hobart",
  VIC: "Australia/Melbourne",
  SA: "Australia/Adelaide",
  QLD: "Australia/Brisbane",
  ZOOM_WEBINAR: "Australia/Melbourne",
  WEBINAR: "Australia/Melbourne"
};

export function timezoneForRegion(region) {
  return timezones[region];
}

export const regionalNumbers = {
  NSW: "0489 077 741",
  ACT: "0489 077 741",
  WA: "0489 077 741",
  NT: "0489 077 741",
  TAS: "0489 077 741",
  VIC: "0489 077 741",
  SA: "0489 077 741",
  QLD: "0489 077 741"
};

export function m1PhoneForRegion(region) {
  return regionalNumbers[region];
}

export function examBoardForRegion(region) {
  const names = {
    ACT: "SSC",
    NSW: "HSC",
    NT: "NTCET",
    QLD: "QCE",
    SA: "SACE",
    TAS: "TCE",
    VIC: "VCE",
    WA: "WACE"
  };
  return names[region];
}

export function stateNamePlusExamBoardForRegion(region) {
  const names = {
    ACT: "Australian Capital Territory (SSC)",
    NSW: "New South Wales (HSC)",
    NT: "Northern Territory (NTCET)",
    QLD: "Queensland (QCE)",
    SA: "South Australia (SACE)",
    TAS: "Tasmania (TCE)",
    VIC: "Victoria (VCE)",
    WA: "Western Australia (WACE)"
  };
  return names[region];
}
